module.exports = __webpack_public_path__ + "static/player-screen-aecc4aba2083f4f7b5252c11641d55c6.png";